export const generateDistributionMovieSlug = (
  pageSlug: string,
  movieSlug: string
) => {
  return `/${pageSlug}/${movieSlug}`;
};
